<template>
  <div class="add-new flex flex-col w-full">
    <Button
      v-if="!enabledModel"
      class="add-new__start-btn self-end"
      type="primary"
      @click="setEnabled(true)"
    >
      {{ $t('pages.localization.add_language') }}
    </Button>
  
    <div
      v-else
      class="add-new__body flex flex-col w-full gap-2"
    >
      <CrossButton
        class="self-end"
        icon-classes="text-base-content"
        @click="cancel(false)"
      />
      <Loader v-if="isLoading" />
      <FormulateForm
        v-else
        class="add-new__form flex gap-4 items-start"
      >
        <FormulateInput
          type="text"
          validation="required" 
          v-model="newLangProfile.name"
          class="flex-1 w-5/12"
          :element-class="(context, classes) => ['flex-1 min-w-full'].concat(classes)"
          :label="$t('pages.localization.language_profile')"
          :placeholder="$t('pages.localization.language_profile')"
        />
        <LangMultiselect
          v-model="newLangProfile.lang"
          validation="required" 
          class="flex-1 w-5/12"
          :disabled="!!defaultData.lang"
          :options="getLangOptions"
          :multiple="false"
          :show-flag="false"
        />
        <Button
          class="add-new__save-btn flex-shrink-0 w-32 mt-8"
          type="primary"
          :disabled="isSaveDisabled"
          @click="updateLangProfile"
        >
          {{ $t('actions.save') }}
        </Button>
      </FormulateForm>
    </div>
  </div>
</template>

<script>
// TODO handle actions (create lang profile)

import { mapActions, mapGetters } from "vuex";
import {
  CrossButton,
} from "@shared/components/icon-buttons";
import Button from "@shared/components/button";
import LangMultiselect from "@shared/components/LangMultiselect/index.vue";
import Loader from "@shared/components/WrappedLoader";

export default {
  name: "create-lang-profile-form",
  components: {
    CrossButton,
    Button,
    LangMultiselect,
    Loader,
  },
  props: {
    enabled: {
      type: Boolean,
      default: false,
    },
    prefillData: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      isLoading: false,
      newLangProfile: {
        lang: null,
        name: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      getLangOptions: "LangStore/getLangOptions",
    }),

    enabledModel: {
      get() {
        return this.enabled;
      },
      set(val) {
        this.$emit("update:enabled", val);
      },
    },

    defaultData() {
      const selectedLang = this.getLangOptions?.find(
        (lang) => lang.id === this.prefillData?.language_id
      ) || null;
      return {
        lang: selectedLang,
        name: this.prefillData?.name || "",
      };
    },

    isSaveDisabled() {
      return !(this.newLangProfile.lang && this.newLangProfile.name);
    },
  },

  watch: {
    enabledModel(val) {
      if (val) {
        this.resetNewLangProfileData();
      }
    },
  },

  async mounted() {
    this.isLoading = true;
    try {
      // TODO fetch lang profile list
      await this.fetchLangOptions();
    } catch (error) {
      console.error("Failed to fetch languages", error)
    }
    this.isLoading = false;
  },

  methods: {
    ...mapActions({
      fetchLangOptions: "LangStore/fetchLangOptions",
    }),

    cancel() {
      this.$emit("cancel");
      this.setEnabled(false);
    },

    setEnabled(payload) {
      this.enabledModel = payload;
    },

    resetNewLangProfileData() {
      this.newLangProfile = { ...this.defaultData };
    },

    updateLangProfile() {
      this.$emit("update", this.newLangProfile);
      this.enabledModel = false;
    },
  },
}
</script>

<style lang="scss" scoped>
</style>